const fitt = require('fitt')
const cnum = fitt.cnum

module.exports = (function () {

  const env = process.env
  const UID = env.UID
  const PORT = env.PORT
  const HOST = env.HOST
  const MEMCACHED_SERVERS = (env.MEMCACHED_SERVERS || '127.0.0.1:11211').split(',')
  const MEMCACHED_POOLSIZE = env.MEMCACHED_POOLSIZE
  const MEMCACHED_TIMEOUT = env.MEMCACHED_TIMEOUT
  const MEMCACHED_RETRIES = env.MEMCACHED_RETRIES
  const MEMCACHED_FAILURES = env.MEMCACHED_FAILURES
  const MEMCACHED_NAMESPACE = env.MEMCACHED_NAMESPACE

  // CDN path for serving App bundles
  const CDN_PATH = env.CDN_PATH

  const GZIPPED_REQUESTS = env.GZIPPED_REQUESTS

  // Site API host names. We use different host names
  // for backchannel calls inside the datacenters vs
  // from the public internet
  const SITE_API_FRONTCHANNEL_HOST = env.SITE_API_FRONTCHANNEL_HOST
  const SITE_API_BACKCHANNEL_HOST = env.SITE_API_BACKCHANNEL_HOST
  const V1_API_FRONTCHANNEL_HOST = env.V1_API_FRONTCHANNEL_HOST
  const V1_API_BACKCHANNEL_HOST = env.V1_API_BACKCHANNEL_HOST
  const NOW_API_FRONTCHANNEL_HOST = env.NOW_FRONTCHANNEL_HOST
  const NOW_API_BACKCHANNEL_HOST = env.NOW_BACKCHANNEL_HOST

  const API_TIMEOUT = env.API_TIMEOUT

  const SCORETC_FRONTCHANNEL_HOST = env.SCORETC_FRONTCHANNEL_HOST
  const SCORETC_BACKCHANNEL_HOST = env.SCORETC_BACKCHANNEL_HOST

  // MEMCACHED DEFAULTS
  const MEMCACHED_LIVE_DATA_TTL = env.MEMCACHED_LIVE_DATA_TTL
  const MEMCACHED_DEFAULT_DATA_TTL = env.MEMCACHED_DEFAULT_DATA_TTL

  // In Memory Caching configurations
  const IN_MEM_CACHE_SHELL_TTL = env.IN_MEM_CACHE_SHELL_TTL
  const IN_MEM_CACHE_SHELL_STALE_TTL = env.IN_MEM_CACHE_SHELL_STALE_TTL
  const IN_MEM_CACHE_I18N_TTL = env.IN_MEM_CACHE_I18N_TTL
  const IN_MEM_CACHE_I18N_STALE_TTL = env.IN_MEM_CACHE_I18N_STALE_TTL
  const SERVER_REQUEST_TIMEOUT = env.SERVER_REQUEST_TIMEOUT

  const PRIMER_ACTIVE = env.PRIMER_ACTIVE
  const PRIMER_SUMMARIES = env.PRIMER_SUMMARIES

  return {
    uid : UID || 'reduxion',
    port : cnum(PORT) || 1377,
    host : HOST || '0.0.0.0',
    // overall request timeout
    serverRequestTimeout: cnum(SERVER_REQUEST_TIMEOUT, 7000, 7000, 10000),
    api: {
      // Specifies the number of milliseconds before the request times out; 5000ms client-side, 1000ms by default
      timeout: cnum(API_TIMEOUT, 3000, 3000, 5000),
      useGzip: (GZIPPED_REQUESTS === 'true')
    },
    cacheDuration: {
      // Duration for which every API is cached by default,
      // can be overridden at each API level
      liveData : cnum(MEMCACHED_LIVE_DATA_TTL) || 5,
      defaultData : cnum(MEMCACHED_DEFAULT_DATA_TTL) || 60,

      // Duration for which pageShell is cached
      shell : cnum(IN_MEM_CACHE_SHELL_TTL) || 300,
      shellStale : cnum(IN_MEM_CACHE_SHELL_STALE_TTL) || 1800,

      // Duration for which translationMap is cached
      translation : cnum(IN_MEM_CACHE_I18N_TTL) || 3600,
      translationStale : cnum(IN_MEM_CACHE_I18N_STALE_TTL) || 1800
    },
    // ideally, this would get merged into the api
    // key, but Object.assign doesnt' do deep copies.
    // TODO: discuss adding underscore/lo-dash/etc.
    apiHost: {
      sCoreTcClient: SCORETC_FRONTCHANNEL_HOST || 'www.espn.com/core',
      sCoreTcServer: SCORETC_BACKCHANNEL_HOST || 'www.espn.com/core',
      sCoreQahost: 'www.espnqa.com/core',
      client: SITE_API_FRONTCHANNEL_HOST || 'site.web.api.espn.com',
      server: SITE_API_BACKCHANNEL_HOST || 'site.web.api.espn.com',
      client_qa: 'site.web.api.espnqa.com',
      server_qa: 'site.web.api.espnqa.com',
      client_sb: 'site.web.api.espnsb.com',
      server_sb: 'site.web.api.espnsb.com',
      client_v1: V1_API_FRONTCHANNEL_HOST || 'api-app.espn.com',
      server_v1: V1_API_BACKCHANNEL_HOST || 'api-app.espn.com',
      now_client: NOW_API_FRONTCHANNEL_HOST || 'now.core.api.espn.com',
      now_server: NOW_API_BACKCHANNEL_HOST || 'now.core.api.espn.com'
    },
    cache: {
      servers : MEMCACHED_SERVERS,
      poolSize : cnum(MEMCACHED_POOLSIZE) || 50,
      timeout : cnum(MEMCACHED_TIMEOUT) || 1000,
      retries : cnum(MEMCACHED_RETRIES) || 1,
      failures : cnum(MEMCACHED_FAILURES) || 1,
      namespace : MEMCACHED_NAMESPACE || ''
    },
    cdnPath: CDN_PATH || '',
    cachePrimer: {
      active: ((PRIMER_ACTIVE === undefined) ? true : (PRIMER_ACTIVE === 'true')),
      primeSummaries: ((PRIMER_SUMMARIES === undefined) ? true : (PRIMER_SUMMARIES === 'true'))
    }

  }
}())



// WEBPACK FOOTER //
// ../config/env.config.js